import React, { useState, useRef, useEffect } from "react";
import { useEnvironment } from "../../context/EnvironmentContext";

const ENV_META = {
  dev: { label: "Development", short: "DEV" },
  stage: { label: "Staging", short: "STG" },
  prod: { label: "Production", short: "PROD" },
};

export default function EnvironmentSelector() {
  const { selectedEnv, changeEnv, envOptions } = useEnvironment();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const meta = ENV_META[selectedEnv] || ENV_META.dev;

  return (
    <div className="env-selector" ref={ref}>
      <div
        className={`env-badge ${selectedEnv}`}
        onClick={() => setOpen(!open)}
      >
        <span className="env-dot" />
        {meta.short}
      </div>

      {open && (
        <div className="env-dropdown">
          {envOptions.map((opt) => {
            const m = ENV_META[opt.value] || {};
            return (
              <div
                key={opt.value}
                className={`env-dropdown-item${selectedEnv === opt.value ? " selected" : ""}`}
                onClick={() => {
                  changeEnv(opt.value);
                  setOpen(false);
                }}
              >
                <span className={`env-dropdown-dot ${opt.value}`} />
                {m.label}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
